/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_New_ButtonInputs */



/**
* | output |
* | --- |
* | "New" |
*
* @param {Style_Guide_Manager_New_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_new_button = /** @type {((inputs?: Style_Guide_Manager_New_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_New_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo")
	return /** @type {LocalizedString} */ ("New")
});